// extracted by mini-css-extract-plugin
module.exports = {"mainTableDiv":"MainTableDiv_mainTableDiv__2KLvo"};